import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid'
import { Autocomplete, Box, Card, CircularProgress, IconButton, Modal, TextField, Tooltip, Typography } from "@mui/material";
import ChartProd01 from "./charts/ChartProd01";
import "../../assets/css/dashboard_styles.css"
import ContratoDataset from "../../components/data/ContratoDataSet";
import SkuDataSet from "../../components/data/UnidadeArmazenamentoDataSet";
import ParceiroDataSet from "../../components/data/parceiroDataset";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import br from "date-fns/locale/pt-BR";
import { Search } from "@mui/icons-material";
import ChartProd02 from "./charts/ChartProd02";
import GridJustificativas from "./grids/GridJustificativas";
import ChartProd03 from "./charts/ChartProd03";
import ChartProd04 from "./charts/ChartProd04";
import SemanaDataSet from "../../components/data/SemanaDataSet";
import DashboardAcompParceirosGrid from "./grids/GridDiario";
import DashParceiroDataset from "../../components/data/DashParceirosDataset";
import { DashAcompParceiros, DashboardAcompParceirosTableSemanal } from "../../components/classes/DashAcompParceiros";

import { useTranslation } from "react-i18next";

export default function DashboardAcompParceirosDetalhe() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === "en-US";

  // STATES
  const [filtroNumeroContratoSap, setFiltroNumeroContratoSap] = useState<string[]>([]);
  const [filtroSkuNome, setFiltroSkuNome] = useState<string[]>([]);
  const [filtroParceiro, setFiltroParceiro] = useState<{ label: string, id: number }[]>([]);
  const [numerosContratoSap, setNumerosContratoSap] = useState<string[]>([]);
  const [skusNomes, setSkusNomes] = useState<string[]>([]);
  const [parceiros, setParceiros] = useState<{ label: string, id: number }[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [contratosIsLoading, setContratosIsLoading] = useState<boolean>(false);
  const [dataInicio, setDataInicio] = useState<Date>();
  const [dataFim, setDataFim] = useState<Date>();
  const [filterControl, setFilterControl] = useState<boolean>(false);
  const [initialized, setInitialized] = useState<boolean>(false);
  const [dashAcompParceirosData, setDashAcompParceirosData] = useState<DashAcompParceiros>();
  const [showModalJustificativas, setShowModalJustificativas] = useState<boolean>(false);
  const [selectedWeek, setSelectedWeek] = useState<DashboardAcompParceirosTableSemanal>();

  // DATA
  const dashAcompParceirosDataset = new DashParceiroDataset();
  const contratoDataSet = new ContratoDataset();
  const skuDataSet = new SkuDataSet();
  const parceirosDataSet = new ParceiroDataSet();
  const semanasDataSet = new SemanaDataSet();

  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    if (initialized) {
      setIsLoading(true);
      dashAcompParceirosDataset
        .getAll(
          filtroNumeroContratoSap,
          filtroSkuNome,
          dataInicio ?? new Date(),
          dataFim ?? new Date(),
          filtroParceiro.map(x => x.id)
        )
        .then((result) => {
          setDashAcompParceirosData(result);
          setIsLoading(false);
        });
    }
  }, [filterControl]);

  useEffect(() => {
    setContratosIsLoading(true);
    setNumerosContratoSap([]);
    contratoDataSet.ListarAtivosMultiplosParceiros(filtroParceiro.map(x => x.id))
      .then((contratos) => {
        setNumerosContratoSap(contratos.map(x => x.numeroContrato + ''));
      })
      .finally(() => setContratosIsLoading(false));
  }, [filtroParceiro])

  const fetchData = async () => {
    try {
      setIsLoading(true);

      var skus = await skuDataSet.ListarAtivos();
      var parceiros = parceirosDataSet.ListarFromCache() ?? await parceirosDataSet.ListarAtivos();

      setSkusNomes(skus.map(x => x.idSKU + ''));
      setParceiros(parceiros.map(x => { return { label: x.apelido + '', id: +x.codigoFornecedorSAP } }));
      await datePickerChange('Inicial', new Date());
      await datePickerChange('Final', new Date());
      setInitialized(true);
      setFilterControl(!filterControl);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  const showJustificativas = (selectedWeek: DashboardAcompParceirosTableSemanal) => {
    setSelectedWeek(selectedWeek);
    setShowModalJustificativas(true);
  }

  const datePickerChange = async (tipo: string, newValue: Date) => {
    if (newValue) {
      var semanas = await semanasDataSet.getAll(newValue.getFullYear());
      var semana = semanas.find(x => x.dias.filter(y => new Date(y).toDateString() == newValue.toDateString()).length > 0);
      switch (tipo) {
        case 'Inicial':
          setDataInicio(semana ? new Date(semana.diaInicial) : newValue);
          break;
        case 'Final':
          setDataFim(semana ? new Date(semana.diaFinal) : newValue);
          break;
        default:
          throw `${t("pages.dashboardTracking.text.dataTypeDoesNotExist")} ${tipo}`;
      }
    }
  }

  return (
    isLoading ?
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
        className="dashboard-container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          className="dashboard-content">
          <CircularProgress size={48} />
          <small style={{ marginTop: 10 }}>{t("pages.dashboardTracking.text.loadingDataPleaseWait")}</small>
        </div>
      </div>
      :
      <>
        <Modal
          open={showModalJustificativas}
          onClose={() => setShowModalJustificativas(false)}
          sx={{
            display: "flex",
            "justifyContent": "center",
            "alignItems": "center",
          }}
          aria-labelledby="modal-modal-title"
        >
          <div style={{ width: "50vw", backgroundColor: 'white' }}>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ backgroundColor: '#eee5db' }}>
              {t("pages.dashboardTracking.text.justifyPercentage")} {selectedWeek?.semana?.descricao}
            </Typography>
            <ChartProd04 data={selectedWeek} />
          </div>
        </Modal>
        <div className="dashboard-container">
          <div className="dashboard-content">
            <Grid
              container
              spacing="10"
              className="dashboard-header"
              sx={{ marginTop: "0" }}
            >
              <Grid item xs={12} lg={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={br}>

                  <div
                    style={{
                      width: "100%",
                      height: "6em",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginRight: 10 }}>
                      <DatePicker
                        label={t("common.initialDate")}
                        value={dataInicio}
                        onChange={(newValue: any) => {
                          if (newValue) {
                            datePickerChange('Inicial', newValue);
                          }
                        }}
                        renderInput={(params: any) => <TextField {...params} />}
                      />
                    </div>
                    <div>
                      <DatePicker
                        label={t("common.finalDate")}
                        value={dataFim}
                        onChange={(newValue: any) => {
                          if (newValue) {
                            datePickerChange('Final', newValue);
                          }
                        }}
                        renderInput={(params: any) => <TextField {...params} />}
                      />
                    </div>
                  </div>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} lg={4}>
                <div
                  style={{
                    width: "100%",
                    height: "6em",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Autocomplete
                    loading={contratosIsLoading}
                    disablePortal
                    id="contratos"
                    options={numerosContratoSap}
                    value={filtroNumeroContratoSap}
                    multiple={true}
                    onChange={(e: any, newValue: string[] | null) => {
                      setFiltroNumeroContratoSap(newValue ?? [""]);
                    }}
                    renderInput={(params) => <TextField {...params} label={t("pages.dashboardTracking.text.portalContract")} />}
                    style={{ zIndex: 1000 }}
                    sx={{ width: '100%' }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} lg={4}>
                <div
                  style={{
                    width: "100%",
                    height: "6em",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Autocomplete
                    disablePortal
                    id="skus"
                    options={skusNomes}
                    value={filtroSkuNome}
                    multiple={true}
                    onChange={(e: any, newValue: string[] | null) => {
                      setFiltroSkuNome(newValue ?? [""]);
                    }}
                    renderInput={(params) => <TextField {...params} label={t("common.skus")} />}
                    style={{ zIndex: 1000 }}
                    sx={{ width: '100%' }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} lg={8}>
                <div
                  style={{
                    width: "100%",
                    height: "6em",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Autocomplete
                    disablePortal
                    id="parceiros"
                    options={parceiros}
                    value={filtroParceiro}
                    multiple={true}
                    onChange={(e: any, newValue: any | null) => {
                      setFiltroParceiro(newValue ?? []);
                    }}
                    renderInput={(params) => <TextField {...params} label={t("common.partners")} />}
                    style={{ zIndex: 1000 }}
                    sx={{ width: '100%' }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} lg={4}>
                <div
                  style={{
                    width: "100%",
                    height: "6em",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title={t("pages.dashboardTracking.text.updateDashboardWithFilteredDara")}>
                    <span>
                      <IconButton onClick={() => setFilterControl(!filterControl)} style={{ borderRadius: "0" }}>
                        <Search />
                        <Typography variant="subtitle2">{t("pages.dashboardTracking.text.applyFilters")}</Typography>
                      </IconButton>
                    </span>
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  noWrap
                  component="div"
                  sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
                  fontSize={12}
                >
                  <b>*</b> {t("pages.dashboardTracking.text.dateFilter")}
                </Typography>
                <Typography
                  noWrap
                  component="div"
                  sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
                  fontSize={12}
                >
                  <b>*</b> {t("pages.dashboardTracking.text.contractFilter")}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing="16" className="dashboard-charts" sx={{ marginTop: "0" }} >
              <Grid item xs={12} flexDirection={'row'} display={'flex'} container spacing={1}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" fontSize="small" sx={{ lineHeight: "1.2em", color: "#4c4c4c" }} >
                    {t("pages.dashboardTracking.text.planned")} X {t("pages.dashboardTracking.text.weeklyDelivered")}
                  </Typography>
                  <ChartProd02 data={dashAcompParceirosData?.dashSemanal} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <GridJustificativas data={dashAcompParceirosData?.tableSemanal?.linhas} openJustificativas={showJustificativas} />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Card className="dashboard-chart__card" sx={{ display: "flex" }}  >
                  <div className="chart-box" style={{ width: "15%" }}>
                    <Box>
                      <Typography variant="subtitle2" >
                        {t("pages.dashboardTracking.text.justification")}
                      </Typography>
                      <div className="h-rule"></div>
                    </Box>
                    <Box className="dashboard-flexbox" pt={2} sx={{ justifyContent: "center", alignItems: "flex-start" }}>

                      <Box className="dashboard-box__item" mb={2} sx={{ minHeight: "78px" }}>
                        <Typography variant="subtitle2" fontSize="small" sx={{ lineHeight: "1.2em", color: "#4c4c4c" }} >
                          {t("pages.dashboardTracking.text.total")} <br /> {t("pages.dashboardTracking.text.over")}
                        </Typography>
                        <div className="h-rule"></div>
                        <Typography variant="subtitle2" pt={1}  >
                          {dashAcompParceirosData?.totalSobraPeriodo}
                        </Typography>
                      </Box>
                      <Box mb={2} className="dashboard-box__item" sx={{ minHeight: "78px" }} >
                        <Typography variant="subtitle2" fontSize="small" sx={{ lineHeight: "1.2em", color: "#4c4c4c" }}  >
                          {t("pages.dashboardTracking.text.total")} <br /> {t("pages.dashboardTracking.text.break")}
                        </Typography>
                        <div className="h-rule"></div>
                        <Typography variant="subtitle2" pt={1} color="#4c4c4c" >
                          {dashAcompParceirosData?.totalQuebraPeriodo}
                        </Typography>
                      </Box>
                    </Box>
                  </div>
                  <div className="chart-box" style={{ margin: "auto" }}>
                    <ChartProd03 data={dashAcompParceirosData?.justificativasSemanal} />
                  </div>
                </Card>
              </Grid>
              <Grid item xs={12} >
                <Card className="dashboard-chart__card" sx={{ display: "flex" }}  >
                  <div className="chart-box" style={{ width: "15%" }}>
                    <Box>
                      <Typography variant="subtitle2" >
                        {isEnglish ? (
                          <>
                            {t("pages.dashboardTracking.text.planned")} X {t("pages.dashboardTracking.text.dailyDelivered")}
                          </>
                        ) : (
                          <>
                            {t("pages.dashboardTracking.text.dailyDelivered")} X {t("pages.dashboardTracking.text.planned")}
                          </>
                        )}
                      </Typography>
                      <div className="h-rule"></div>
                    </Box>
                    <Box className="dashboard-flexbox" pt={2} sx={{ justifyContent: "center", alignItems: "flex-start" }}>

                      <Box className="dashboard-box__item" mb={2} sx={{ minHeight: "78px" }}>
                        <Typography variant="subtitle2" fontSize="small" sx={{ lineHeight: "1.2em", color: "#4c4c4c" }} >
                          {isEnglish ? (
                            <>
                              {t("pages.dashboardTracking.text.planned")} <br /> {t("pages.dashboardTracking.text.quantity")}
                            </>
                          ) : (
                            <>
                              {t("pages.dashboardTracking.text.quantity")} <br /> {t("pages.dashboardTracking.text.planned")}
                            </>
                          )}
                        </Typography>
                        <div className="h-rule"></div>
                        <Typography variant="subtitle2" pt={1}  >
                          {dashAcompParceirosData?.totalPlanejadoPeriodo}
                        </Typography>
                      </Box>
                      <Box mb={2} className="dashboard-box__item" sx={{ minHeight: "78px" }} >
                        <Typography variant="subtitle2" fontSize="small" sx={{ lineHeight: "1.2em", color: "#4c4c4c" }}  >
                          {isEnglish ? (
                            <>
                              {t("pages.dashboardTracking.text.delivered")} <br /> {t("pages.dashboardTracking.text.quantity")}
                            </>
                          ) : (
                            <>
                              {t("pages.dashboardTracking.text.quantity")} <br /> {t("pages.dashboardTracking.text.delivered")}
                            </>
                          )}
                        </Typography>
                        <div className="h-rule"></div>
                        <Typography variant="subtitle2" pt={1} color="#4c4c4c" >
                          {dashAcompParceirosData?.totalEntreguePeriodo}
                        </Typography>
                      </Box>
                    </Box>
                  </div>
                  <div className="chart-box" style={{ margin: "auto" }}>
                    <ChartProd01 data={dashAcompParceirosData?.dashDiario} />
                  </div>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <DashboardAcompParceirosGrid data={dashAcompParceirosData?.tableDiario?.linhas} />
              </Grid>
            </Grid>
          </div >
        </div >
      </>

  );
} 